export default __webpack_public_path__ + "static/media/ALeushchenko.960b5fb3.png";